import {
    Dialog,
    Button,
    Typography,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";

interface UploadListErrorModalProps {
    openDialog: boolean;
    setOpenDialog: (open: boolean) => void;
}

export const UploadListErrorModal = ({ openDialog, setOpenDialog }: UploadListErrorModalProps) => {

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            fullWidth
            maxWidth="sm"
            aria-labelledby="upload-list-error-dialog-title"
        >
            <DialogTitle id="upload-list-error-dialog-title">
                Upload Call List Error
            </DialogTitle>

            <DialogContent dividers>
                <Typography variant="body1" color="error" sx={{ textAlign: "center", py: 2 }}>
                    There is already an active call list in progress. You cannot create a new one until the existing list is completed.
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCloseDialog} variant="contained" color="primary">
                    Okay
                </Button>
            </DialogActions>
        </Dialog>
    );
};
